<template>
  <div class="basic-single-report">
    <header class="header">
      <span class="header-back" @click="handleChange">
        <i class="el-icon-arrow-left" data-io-click="tracker"></i>返回
      </span>
      <div class="report-button">
        <span v-if="showClassReport" :class="isClassReport ? 'menu-tab actived' : 'menu-tab'" @click="changeRouter('examine-classReport-basic')">班级报告</span>
        <span v-if="showGradeReport" :class="!isClassReport ? 'menu-tab actived' : 'menu-tab'" @click="changeRouter('examine-gradeReport-basic')">校级报告</span>
      </div>
      <div style="flex: 1;"></div>
      <el-button v-if="$store.state.backDoor" @click="markSchoolExam" size="mini" type="danger" style="height: 30px;margin-top: 10px;">优先打标</el-button>

      <div class="export-report">
        <div style="margin-top:10px;">
          <div class="top" @click="showClassReportExportModal()">
            <span>导出报表
              <img src="../../assets/images/export-report.png" style="width: 16px; margin-left: 4px;" /></span>
          </div>
          <div style="height:18px;clear:both"></div>
        </div>
      </div>

      <!--导出报告提示框-->
      <yue-dialog title="提示" :visible.sync="exportDialogVisible" size="tiny">
        <el-row>
          <el-col :span="12" style="text-align:right;color:#333;font-size:15px;line-height:30px;">
            <span v-if="exportLoading">报表生成中</span>
            <span v-if="!exportLoading"></span>
          </el-col>
          <el-col :span="12">
            <div class="spinner" v-if="exportLoading">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </el-col>
        </el-row>
        <span @click="exportDialogVisible = false" v-if="!exportLoading" style="text-align: center;display: inline-block;width: 100%;" download="proposed_file_name">
          报表生成成功，点击
          <a :href="url" style="text-decoration: underline;color: #2877FF;">下载</a>
        </span>
      </yue-dialog>
    </header>

    <div class="info-wrapper">
      <div class="info">
        <h4 :title="exam.examName" class="exam-name">{{ exam.examName }}</h4>
        <div class="reletive" v-if="exam.isMore === 1">
          <img src="~images/entrance_exam.png" />
          <span>联考</span>
        </div>
        <div class="reletive" v-else-if="exam.isMore === 2">
          <img src="~images/region_exam.png" />
          <span>区域统考</span>
        </div>
        <div class="date">
          <img src="~images/time.png" width="16" />
          <label>{{ exam.date }}</label>
        </div>
        <div class="reletive">
          <img src="~images/report-grade.png" />
          <span>{{exam.gradeName}}</span>
        </div>
        <div class="reletive">
          <img src="~images/report-subject.png" />
          <span>{{exam.subjectName}}</span>
        </div>
        <div v-if="tongFenClassTip" class="grading-tip" :title="tongFenClassTip">
          {{ tongFenClassTip }}
        </div>
        <div class="report-type" v-if="userInfo.branchOfLearning == 1 &&
          ($route.name == 'examine-gradeReport-basic' ||
            $route.name == 'examine-gradeReport-comment' ||
            $route.name == 'examine-gradeReport-transcript')
        ">
          <el-button @click="branch = 2" type="primary" size="small" :plain="branch == 1">理科班</el-button>
          <el-button @click="branch = 1" type="primary" size="small" :plain="branch == 2">文科班</el-button>
        </div>
      </div>
      <!-- 分班统分时，如果所有班级没有全部生成报告，则班级报告处不显示切换教学班，因为一个教学班的学生可能分布在多个行政班 -->
      <div v-if="showReport && hasTeachType && ((isTongFen && tongFenClassTip) || !isTongFen)&& exam.isMore !== 2" class="model-dialog" @click="{ if (isChangeReportType) { reportModalDialog = true } }">
        <img src="~images/report/class.png" height="18" />
        <span :style="{ 'color': `${isChangeReportType ? '#2877FF' : '#999999'}` }">
          {{ reportType == 0 ? '行政班' : '教学班'}}
        </span>
        <img src="~images/report/switch.png" height="14" />
      </div>

      <!-- 试卷讲评页显示 -->
      <template v-if="$route.name == 'examine-classReport-comment'">
        <div class="export_paper_report">
          <el-button style="padding-top:8px;padding-bottom:8px" round size="small" type="primary" @click="handlePaperReport('CLASS_EXAM_PAPER_INFO')">试卷讲评报告</el-button>
        </div>
      </template>

      <div class="tool">
        <div class="select-round" v-if="isClassReport">
          <el-select v-model="classId" size="mini" placeholder="班级">
            <el-option v-for="item in classList" :key="item.id" :label="`${item.className}${item.hasData?'':'(未扫描)'}`" :value="item.id"></el-option>
          </el-select>
        </div>

        <div v-else class="screen_login" @click="pathToScreen()">
          <img src="~images/project_mode.png" width="34" />
          <span>进入投影模式</span>
        </div>

        <a v-if="exam.isMore !== 2" href="javascript:void(0)" @click="reportSettingVisible = true">
          <img src="~images/setting.png" width="24" />
        </a>
      </div>
    </div>

    <div class="main" v-if="showReport">
      <div class="nav-wrap">
        <nav-bar :routers="routers" :class="fixedClass"></nav-bar>

        <div class="qrcode">
          <img v-if="$store.getters.isTest" src="~images/qrcode_testing.png" />
          <img v-else src="~images/qrcode.png" />
          <p>手机阅卷并查看报告</p>
        </div>
      </div>

      <keep-alive :include="includeRoutes">
        <router-view :param="param" :grade-name="gradeName" :grade-id="gradeId" :class-list="classList" :class-id="classId" :class-name="className" :exam-info="examInfo" :isExamSplit="isExamSplit" :report-type="reportType" :branch="branch" :dialog-class-info="dialogClassInfo"></router-view>
      </keep-alive>
    </div>

    <div class="loading-bg" v-else v-loading="examLoading">
      <p>{{ examLoadingMsg }}</p>
    </div>

    <!--设置弹窗-->
    <yue-dialog title="设置" width="760px" center :visible.sync="reportSettingVisible" class="report-setting" :before-close="handleCloseSetting">
      <ul class="setting-nav">
        <li v-for="(item, index) in navList.slice(0, isClassReport ? 3 : 4)" :key="item.name" @click="changeNav(index)" :class="{ active: index === navActive }">
          {{ item.name }}
        </li>
      </ul>
      <!--分数等级设置-->
      <div class="setting-body" v-if="navTab === 0">
        <p style="height: 30px">总分 {{ param.totalScore || '--' }}分</p>
        <div class="table-wrap" v-loading="paramLoading">
          <el-form :model="model" ref="levelForm">
            <el-table size="small" :data="model.paramList" border>
              <el-table-column prop="rank" align="center" label="系统分数等级"></el-table-column>
              <el-table-column prop="percent" align="center" label="达到等级比例">
                <template slot-scope="scope">{{ scope.row.percent }}%</template>
              </el-table-column>
              <el-table-column prop="parent" align="center" label="家长显示名称"></el-table-column>
              <el-table-column prop="edit" align="center" width="180" label="本次考试修改">
                <template slot-scope="scope">
                  <el-form-item :prop="'paramList.' + scope.$index + '.edit'" :rules="model.rules.edit">
                    <el-input class="level-input" size="small" v-model="scope.row.edit" clearable></el-input>
                    <span>&nbsp;%</span>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <!--table wrap end-->
      </div>
      <!--特殊试卷参与统计设置-->
      <div class="count-body" v-if="navTab === 1">
        <el-form label-width="240px" class="top-form" label-position="left">
          <el-form-item size="small" label="缺考：">
            <el-radio-group v-model="param.analMiss">
              <el-radio :label="true">参与</el-radio>
              <el-radio :label="false">不参与</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item size="small" label="无名氏：">
            <el-radio-group v-model="param.analNo">
              <el-radio :label="true">参与</el-radio>
              <el-radio :label="false">不参与</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item size="small" label="0分卷：">
            <el-radio-group v-model="param.analZero">
              <el-radio :label="true">参与</el-radio>
              <el-radio :label="false">不参与</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item size="small" label="考试报告是否显示综合分相关数据：">
            <el-radio-group v-model="param.openComprehensive">
              <el-radio :label="1">是&nbsp;&nbsp;&nbsp;&nbsp;</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <!-- 基础成绩换算 -->
      <div class="matrixing" v-if="navTab === 2">
        <el-form :model="matrixing" :rules="matrixingRules" ref="matrxingForm" label-width="240px" class="top-form" size="small">
          <el-form-item label="换算系数：" prop="value">
            <el-input type="number" v-model="matrixing.value" style="width: 260px" placeholder="默认值为1，最多支持两位小数" />
          </el-form-item>
        </el-form>
      </div>
      <div class="matrixing" style="padding: 40px 0 0 150px" v-if="navTab === 3">
        <el-form ref="form" size="mini" :model="gradeForm" label-width="155px">
          <el-form-item label="年级综合分">
            <el-radio-group v-model="gradeForm.gradeSynthesisScore">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="与校均之差">
            <el-radio-group v-model="gradeForm.schoolInequality">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年级平均分">
            <el-radio-group v-model="gradeForm.gradeAvg">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年级分数等级">
            <el-radio-group v-model="gradeForm.gradeScoreLevel">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="与年级均值的距离">
            <el-radio-group v-model="gradeForm.gradeAvgDistance">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="每道题的年级占比">
            <el-radio-group v-model="gradeForm.everyTopicPercent">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="个人难易题年级得分率">
            <el-radio-group v-model="gradeForm.everyoneGradeScorePercent">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年级名次">
            <el-radio-group v-model="gradeForm.gradeRank">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="个人击败本校占比">
            <el-radio-group v-model="gradeForm.personalDefeatSchoolPercent">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年级得分率">
            <el-radio-group v-model="gradeForm.gradeScorePercent">
              <el-radio :label="1">显示</el-radio>
              <el-radio :label="0">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" :loading="saveParamLoading" @click="submitForm()">保存</el-button>
      </span>
    </yue-dialog>

    <!-- 切换报告生成模式 -->
    <yue-dialog title="切换报告生成模式" :visible.sync="reportModalDialog" size="small" center>
      <p class="report-modal-content">
        <label>当前为“</label>
        <span>{{ reportType == 0 ? '行政班' : '教学班' }}</span>
        <label>”分析模式，是否切换为“</label>
        <span>{{ reportType == 0 ? '教学班' : '行政班' }}</span>
        <label>”？</label>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reportModalDialog = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="switchReportModal()">切 换</el-button>
      </span>
    </yue-dialog>

    <!-- 导出班级报告 -->
    <yue-dialog :title="`导出${exportReportType === 'CLASS_EXAM_PAPER_INFO' ? '试卷讲评' : '班级'}报告`" :visible.sync="dialogPaperReportVisible">
      <div class="export-grade-report">
        <div class="export-grade-header">
          <div>
            <template v-if="exportReportType !== 'CLASS_EXAM_PAPER_INFO'">
              <el-button v-if="schoolClassAllReport.state+''!='2'" type="primary" size="small" :disabled="schoolClassAllReport.state+'' === '1'" @click="createReportExport(schoolClassAllReport)">一键生成</el-button>
              <el-button type="primary" size="small" v-else-if="schoolClassAllReport.state+'' === '2'" @click="handleDownload(schoolClassAllReport)">一键下载</el-button>
            </template>
          </div>
          <div>
            <span>点击刷新查看导出进度</span>
            <el-button type="primary" size="small" @click="handlePaperReport()">刷新</el-button>
          </div>
        </div>
        <el-table size="mini" :data="paperReportData" v-loading="paperReportExportLoading">
          <el-table-column property="fileName" align="center" label="班级" width="150">
          </el-table-column>
          <el-table-column label="导出状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.state + '' === '0'">等待处理</span>
              <span v-else-if="scope.row.state + '' === '1'">处理中</span>
              <span v-else-if="scope.row.state + '' === '2'">已完成</span>
              <span v-else-if="scope.row.state + '' === '3'">处理失败</span>
              <span v-else>未导出</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" v-if="['2', '3', '4'].indexOf(scope.row.state + '') > -1" @click="createReportExport(scope.row)">重新生成</el-button>
              <el-button type="text" v-if="scope.row.state === null || scope.row.state + '' === '0'" @click="createReportExport(scope.row)">导出</el-button>
              <el-button type="text" @click="handleDownload(scope.row)" v-if="scope.row.url && scope.row.state + '' == '2'">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </yue-dialog>

    <!-- 导出校级报告 -->
    <export-modal title="导出校级报告" :reportList="reportList" :show-six-rete="false" :school-all-report="schoolAllReport" @click-item="clickItem" ref="exportModal"> </export-modal>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import { getExam, getExamParam, updateSingleExam, updateExamParam } from '@/api/exam/exam'
import { mapGetters } from 'vuex'
import util from '@/utils/util'
import { domain } from '@/config'
import { magicApi } from '@/utils/magic'
import { baseApi, reportApi, mainApi, configApi, examApi } from "@/v2/utils/api";
import { reportData } from '@/v2/utils/data';
import ExportModal from "@/v2/views/components/ExportModal"
import auth from "@/v2/utils/auth";

export default {
  components: {
    NavBar,
    ExportModal
  },

  data () {
    var numCheck = (rule, value, callback) => {
      let self = this
      let index = parseFloat(rule.field.split('.')[1])

      switch (index) {
        case 0: {
          if (value < parseFloat(self.model.paramList[1].edit)) {
            callback(new Error('值需大于下一等级'))
          } else {
            callback()
          }
          break
        }
        case self.model.paramList.length - 1: {
          callback()
          break
        }
        default: {
          if (value > parseFloat(self.model.paramList[index - 1].edit) || value < parseFloat(self.model.paramList[index + 1].edit)) {
            callback(new Error('值需在上下等级间'))
          } else {
            callback()
          }
        }
      }
    }

    // 换算系数验证
    var checkMatrixing = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入换算系数'))
      }

      if (parseFloat(value).toString() == 'NaN') {
        callback(new Error('请输入数字值'))
      } else {
        if (value < 0.01) {
          callback(new Error('换算系数不能低于0.01'))
        } else if (value > 10) {
          callback(new Error('换算系数不能大于10'))
        } else {
          callback()
        }
      }
    }

    return {
      schoolAllReport: {},
      branch: 1,
      exportGradeReportListLoading: false,
      gradeReportExportList: [],
      paperReportExportLoading: false,
      dialogPaperReportVisible: false,
      paperReportData: [],
      currentHistoryPathArray: [],
      includeRoutes: [],
      showCompScore: 0, // 是否显示综合分
      hasTeachType: 0,
      examLoading: true,
      examLoadingMsg: '',
      showReport: false,
      showGradeReport: false,
      showClassReport: false,
      reportType: 0, // 报告类型 0行政班 1教学班
      reportModalDialog: false,
      domain: domain,
      param: {}, // 考试设置参数
      paramLoading: false, // 参数加载
      saveParamLoading: false, // 参数提交
      examInfo: {}, // 当前考试所有信息
      classId: '',
      className: '',
      examId: '',
      // 1为拆分考试
      isExamSplit: 0,
      schoolId: '',
      gradeId: '',
      gradeName: '',
      exam: {},
      isClassReport: null,
      changeFull: false,
      reportSettingVisible: false,
      routers: [],
      classList: [],

      //设置 - 头部导航
      navActive: 0,
      navTab: 0,
      navList: [
        {
          name: '分数等级',
          type: 1
        },
        {
          name: '特殊试卷参与统计',
          type: 2
        },
        {
          name: '基础成绩换算',
          type: 3
        },
        {
          name: '年级数据显示',
          type: 4
        }
      ],
      gradeForm: {
        gradeSynthesisScore: 1,
        schoolInequality: 1,
        gradeAvg: 1,
        gradeScoreLevel: 1,
        gradeAvgDistance: 1,
        everyTopicPercent: 1,
        everyoneGradeScorePercent: 1,
        gradeRank: 1,
        personalDefeatSchoolPercent: 1,
        gradeScorePercent: 1,
      },
      value: '1',

      //左侧栏
      fixedClass: '',

      //设置 -分数等级
      subjectField: '',
      subjectList: [],
      model: {
        paramList: [],
        rules: {
          edit: [
            { required: true, message: '请填写等级比例', trigger: 'blur' },
            {
              pattern: /^[0-9]+.?[0-9]{0,2}$/,
              message: '请输入数字,最多支持两位小数',
              trigger: 'blur'
            },
            { validator: numCheck, trigger: 'blur' }
          ]
        }
      },

      //设置 - 特殊试卷设置
      form: {
        miss: 0,
        noName: 0,
        zero: 0
      },

      //导出报告数据
      reportNameList: [],
      exportDialogVisible: false,
      exportLoading: false,
      url: '',

      //导出校级报告
      gradeReportList: [
        {
          key: '成绩单',
          value: [{ classId: 'grade', reportName: '单科年级成绩单', checked: false }],
          checked: false
        },
        {
          key: '逐题分析表',
          value: [
            {
              classId: 'class',
              reportName: '按班级逐题分析报表',
              checked: false
            },
            {
              classId: 'student',
              reportName: '按学生逐题分析报表',
              checked: false
            }
          ],
          checked: false
        },
        {
          key: '题型分析报表',
          value: [
            {
              classId: 'class',
              reportName: '按班级题型分析报表',
              checked: false
            },
            {
              classId: 'student',
              reportName: '按学生题型分析报表',
              checked: false
            }
          ],
          checked: false
        },
        {
          key: '基础成绩分析表',
          value: [
            {
              classId: 'group',
              reportName: '各班基础指标对比分析',
              checked: false
            }
          ],
          checked: false
        },
        {
          key: '分组分析表',
          value: [{ classId: 'group', reportName: '分组分析', checked: false }],
          checked: false
        },
        {
          key: '任选考试比对表',
          value: [
            {
              classId: 'arbitrarily',
              reportName: '任选考试比对表',
              checked: false
            }
          ],
          checked: false
        }
      ],
      gradePopVisible: false,

      //导出班级报告
      classReportList: [],
      xzClassList: [], // 行政班列表
      teachClassList: [], // 教学班列表

      // 基础成绩换算
      matrixing: {
        value: ''
      },

      matrixingRules: {
        value: [
          { required: true, message: '请输入换算系数', trigger: 'blur' },
          {
            pattern: /^[0-9]+.?[0-9]{0,2}$/,
            message: '请输入数字,最多支持两位小数',
            trigger: 'blur'
          },
          { validator: checkMatrixing, trigger: 'blur' }
        ]
      },

      reportConfig: reportData.getQueryItems('单校行政').list,
      teachReportConfig: reportData.getQueryItems('单校教学').list,
      sixRateList: reportData.getSixRate(),
      subsectionScoreConfig: [],
      checkQuestionScorelList: [], // 已选择小题分报表配置
      exportReportType: '', // 导出报表类型
      schoolClassAllReport: {}, // 班级全部
      tongFenClassList: [],
      reportList: [],
      dialogClassInfo: true
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo',
      gradeList: 'getGradeList'
    }),
    isChangeReportType () {
      return (this.reportType === 0 && this.teachClassList.length > 0) || (this.reportType === 1 && this.xzClassList.length > 0)
    },
    categoryClassType () {
      return `SCHOOL_SINGLE_${this.reportType === 1 ? 'TEACH' : 'ADMIN'}_CLASS_COLLECTION_ZIP`
    },
    categoryType () {
      return `${this.reportType === 1 ? 'TEACH_' : ''}SCHOOL_SINGLE_REPORT_ZIP`
    },
    isTongFen () {
      return this.$route.query.isFenBanTongFen + '' === 'true'
    },
    tongFenClassTip () {
      if (this.isTongFen) {
        const names = []
        for (let index = 0; index < this.tongFenClassList.length; index++) {
          const element = this.tongFenClassList[index];
          if (element.reportStatus === 'YES') {
            names.push(element.className)
          }
        }
        if (names.length) {
          if (names.length === this.tongFenClassList.length) {
            return '全部参考班级已完成批阅、统分'
          } else {
            return `${names.join('、')}已完成批阅、统分`
          }
        }
      }
      return ''
    }
  },
  mounted () {
    // 固定左侧导航菜单
    window.addEventListener('scroll', this._navbarFixed)
    this.hasTeachType = parseInt(sessionStorage.getItem('hasTeachType') || 0)
    this.setRoutes(this.$route.name)
    this.examId = this.$route.params.id
    this.schoolId = this.userInfo.schoolId
    this._getExam()
    this.initWaterMark()
    this.getReportState()
  },
  methods: {
    clickItem: function (info) {
      this[info.method](info.params)
    },
    getReportState () {
      if (this.isTongFen) {
        reportApi.examClassReportState(this.examId, this.schoolId).then(resp => {
          if (resp.body) {
            this.tongFenClassList = resp.body
          }
        })
      }
    },
    markSchoolExam () {
      magicApi.markSchoolExam({
        examId: this.examId,
        schoolId: this.schoolId
      }).then(resp => {
        this.$message.info(resp.message || '操作完成')
      })
    },

    initWaterMark () {
      if (sessionStorage.getItem('region-report-watermark') === '1') {
        watermark.init({
          watermark_txt: this.userInfo.nickName + '\n' + this.userInfo.loginName + '\n' + util.formatDate(new Date()),
          watermark_color: '#e2e2e2', //水印字体颜色
          watermark_fontsize: '14px', //水印字体大小
          watermark_alpha: 0.5, //水印透明度，要求设置在大于等于0.005
          watermark_angle: 25, //水印倾斜度数
          watermark_width: 100, //水印宽度
          watermark_height: 100, //水印长度
          watermark_parent_node: '',
          monitor: false,
          show: true
        })
        watermark.load({
          show: true
        })
      }
    },
    // 显示校级报告导出模态框
    exportData (isInit = false) {
      if (isInit) {
        this.checkQuestionScorelList = this.subsectionScoreConfig.map(s => s.value)
      }

      let params = {
        examId: this.examId,
        schoolId: this.userInfo.schoolId,
      }
      const self = this
      const type = this.reportType === 0 ? 'reportConfig' : 'teachReportConfig'
      params.types = self[type].map(s => s.value)

      reportApi.checkExportTask(params).then(res => {
        const paperReportData = []
        if (res.success) {
          let schoolAllReport = {}
          if (self.isClassReport) {
            for (let item in res.body) {
              if (item === self.categoryType) {
                schoolAllReport = res.body[item]
              } else {
                const schoolClass = {
                  classId: item,
                  ...res.body[item]
                }
                paperReportData.push(schoolClass)
              }
            }
          } else {
            schoolAllReport = res.body.find(s => s.category === self.categoryType)
            paperReportData.push(...res.body.filter(s => s.category !== self.categoryType))
          }

          self.schoolAllReport = schoolAllReport
          self.reportList = paperReportData;
        }
        self.$refs.exportModal.open([], self.checkQuestionScorelList)
      })
    },

    // 导出批阅报告
    createReadMarkExport (param) {
      const params = this.getReportExportParams(param.row)
      reportApi[`${param.type}ReportExport`](params).then(res => {
        if (res.success) {
          this.exportData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    // 显示班级报告导出模态窗
    showClassReportExportModal () {
      if (this.isClassReport) {
        let type = 'CLASS_COLLECTION'
        if (this.reportType === 1) {
          type = 'TEACH_CLASS_COLLECTION'
        }
        this.handlePaperReport(type)
      } else {
        this.exportData(true)
      }
    },

    //刷新校级报告导出
    refreshSchoolReportExport () {
      const type = this.reportType === 0 ? 'reportConfig' : 'teachReportConfig'
      const types = this[type].map(s => s.value);
      this.getGradeReportExportList(types)
    },

    // 获取年级报告导出列表
    async getGradeReportExportList (types) {
      let params = {
        examId: this.examId,
        schoolId: this.userInfo.schoolId,
        types: types
      }

      this.exportGradeReportListLoading = true
      let res = await reportApi.checkExportTask(params)
      setTimeout(() => {
        this.exportGradeReportListLoading = false
      }, 200)

      if (res.success) {
        this.schoolAllReport = res.body.shift()
        this.gradeReportExportList = res.body
      } else {
        this.$message.error(res.message)
      }
    },

    // 导出或重新生成报告
    async createReportExport (row) {
      let params = this.getReportExportParams(row)
      let method = 'createReportExport'
      if (row.id) {
        method = 'refreshReportExport'
      }
      let res = await reportApi[method](params)
      if (res.success) {
        if (this.isExportClassReport(row.category)) {
          this.handlePaperReport()
        } else {
          if (this.reportType === 0) {
            this.refreshSchoolReportExport()
          } else {
            this.showSchoolReportExportModal()
          }
        }
      } else {
        this.$message.error(res.message)
      }
    },
    checkQuestionScorel (val) {
      this.checkQuestionScorelList = val
    },
    // 获取年级报告导出文件参数
    getReportExportParams (row) {
      const excludeProperties = [];
      let param = ''
      if (row.category.indexOf('SCORE_DETAIL') > -1) {
        const list = this.subsectionScoreConfig.filter(s => !this.checkQuestionScorelList.some(c => c === s.value))
        excludeProperties.push('school')
        for (let item of list) {
          excludeProperties.push(item.value)
        }
      }

      if (this.isExportClassReport(row.category)) {
        param = row.classId
      }

      return {
        id: row.id ? row.id : '',
        examId: this.examId,
        schoolId: this.userInfo.schoolId,
        module: "REPORT",
        paramModel: {
          examId: this.examId,
          schoolId: this.userInfo.schoolId,
          excludeProperties: excludeProperties,
          type: row.category,
          param: param ? param : '',
          async: true,
          userId: this.userInfo.userId,
        }
      }
    },
    // 是否导出班级报表
    isExportClassReport (category) {
      return ['CLASS_EXAM_PAPER_INFO', 'CLASS_COLLECTION', 'TEACH_CLASS_COLLECTION', this.categoryClassType].indexOf(category) > -1
    },
    // 下载
    handleDownload (row) {
      window.location.href = row.url
    },
    // 班级报告
    async handlePaperReport (type) {
      if (util.isEmpty(type)) {
        type = this.exportReportType
      }
      this.exportReportType = type
      this.paperReportExportLoading = true
      const params = {
        examId: this.examId,
        schoolId: this.userInfo.schoolId,
        classIds: this.classList.filter(s => s.hasData).map((c) => c.id),
        type: type
      }

      reportApi.getClassReviewingTheTestPapers(params).then(res => {
        this.paperReportExportLoading = false
        const paperReportData = []
        if (res.success) {
          for (let item in res.body) {
            if (item == this.categoryClassType) {
              this.schoolClassAllReport = res.body[item]
            } else {
              const schoolClass = {
                classId: item,
                ...res.body[item]
              }
              paperReportData.push(schoolClass)
            }
          }
        } else {
          this.$message.error(res.message)
        }
        this.paperReportData = paperReportData
        this.dialogPaperReportVisible = true
      })
    },
    // 校级报告投屏模式
    pathToScreen () {
      let params = {
        reportType: this.reportType,
        gradeName: this.gradeName,
        classId: this.classId,
        classList: this.classList,
        className: this.className,
        examInfo: this.examInfo,
        showCompScore: this.showCompScore
      }
      window.sessionStorage.setItem('params', JSON.stringify(params))

      this.$router.push({
        path: '/exam/single/report/screen/' + this.examId
      })
    },

    // 切换教学模式
    switchReportModal () {
      // 教学班
      if (this.reportType == 0) {
        // 没有行政班权限
        if (this.teachClassList.length === 0) {
          this.$message.warning('当前为行政班分析模式，您无教学班权限，无法切换')
          return
        }

        this.reportType = 1
        this.classList = this.teachClassList
      } else {
        // 没有行政班权限
        if (this.xzClassList.length === 0) {
          this.$message.warning('当前为教学班分析，您无行政班权限，无法切换')
          return
        }

        this.reportType = 0
        this.classList = this.xzClassList
      }

      this.classId = this.classList[0].id
      this.reportModalDialog = false

      this._updateSingleExam()
    },

    // 更新报告类型（行政班OR教学班）
    async _updateSingleExam () {
      let showType = this.reportType

      let params = {
        id: this.examId,
        schoolId: this.userInfo.schoolId,
        showType: showType
      }

      const loading = this.$loading({
        lock: true,
        text: '切换中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      let resp = await updateSingleExam(params)
      loading.close()

      if (resp.success) {
      } else {
        this.$message({
          message: resp.message,
          type: 'error'
        })
      }
    },

    // 获取带权限的班级列表
    async getExamClassList () {


      try {
        // 获取行政班数据
        let params = {
          examId: this.examId,
          schoolId: this.schoolId,
          userId: this.userInfo.userId,
          isTeach: false
        }

        let resp = await baseApi.getExamReportClassList(params)

        let classList = []
        if (resp.success) {
          if (Array.isArray(resp.body) && resp.body.length) {
            this.xzClassList = resp.body
            if (this.reportType === 0) {
              this.classId = resp.body[0].id
              classList = resp.body
            }
          } else {
            this.reportType = 1
          }
          this.classList = classList
        }

        // 获取教学班数据
        params.isTeach = true

        let teaResp = await baseApi.getExamReportClassList(params)

        if (teaResp.success) {
          if (Array.isArray(teaResp.body) && teaResp.body.length) {
            this.teachClassList = teaResp.body
            if (this.reportType === 1) {
              this.classId = teaResp.body[0].id
              classList = teaResp.body
            }
          }

          this.classList = classList
        }
      } finally {
        this.examLoading = false
      }

    },

    // 判断当前权限是否有查看年级报告权限
    _checkHasGradeReport (arr, val) {
      for (let item of arr) {
        if (item.permCode === val) {
          return true
        }
      }

      return false
    },

    //根据examId查询考试、班级信息
    async _getExam () {
      let resp = await getExam(this.examId)
      if (resp.body) {
        this.exam = resp.body
        this.options = this.exam.classes
        this.exam.date = util.formatDate(this.exam.createTime)
        await this._resizeExamData(this.exam)
        this._postGetLevel(this.exam)
        await this.getExamAuth(this.exam)
      } else {
        this.$message({
          type: 'error',
          message: resp.message
        })
      }
    },

    async getExamAuth (exam) {
      const params = { schoolId: this.userInfo.schoolId, ids: { EXAM: [this.examId] } }
      const resp = await mainApi.getExamPerms(params)
      if (resp && resp.body) {
        exam.permsDict = {
          perms: resp.body[this.examId] || [],
          gradeId: [exam.bigGradeId],
          subjectCode: [exam.subjectCode],
          classId: [...exam.classIds, ...exam.teachClassIds]
        }
        // 回写到路径数组中，用于路由跳转的权限判断
        // 搜索标记：School-Report
        this.showClassReport = auth.checkAuthPerm('Class-Report', exam.permsDict)
        this.showGradeReport = auth.checkAuthPerm('School-Report', exam.permsDict)
        const pathArray = JSON.parse(YJ_SCHOOL_STORAGE.getItem('pathArray')).filter(item => item !== 'Class-Report' && item !== 'School-Report')
        if (this.showClassReport) {
          pathArray.push('Class-Report')
        }
        if (this.showGradeReport) {
          pathArray.push('School-Report')
        }
        YJ_SCHOOL_STORAGE.setItem('pathArray', JSON.stringify(pathArray))
        this.showReport = this.showClassReport || this.showGradeReport
      }
      if (!this.showReport) {
        this.examLoadingMsg = '抱歉，您没有查看任何报告的权限，请联系管理员'
      }
    },

    // 重新封装当前考试数据
    async _resizeExamData (exam) {
      // 设置拆分考试
      this.isExamSplit = exam.isSplit
      exam.classList = exam.classes
      exam.subjectList = []
      for (let key in exam.subject) {
        exam.subjectList.push(exam.subject[key])
      }
      exam.gradeName = this._getGradeName(exam.grade)
      exam.bigGradeId = exam.gradeId
      exam.gradeId = exam.grade
      this.examInfo = exam
      this.gradeId = exam.gradeId
      this.gradeName = exam.gradeName
      this.reportType = exam.showType || 0
      await this.getExamClassList()
    },

    _getGradeName (gradeNum) {
      let grade = this.gradeList.find((item) => item.gradeNum === gradeNum)
      return grade ? grade.gradeName : ''
    },

    async _saveParam () {
      let gradeForm = JSON.parse(JSON.stringify(this.gradeForm))
      let params = {
        analMiss: this.param.analMiss,
        analNo: this.param.analNo,
        analZero: this.param.analZero,
        openComprehensive: this.param.openComprehensive,
        examId: this.examId,
        wonderRate: 0,
        excelRate: 0,
        goodRate: 0,
        passRate: 0,
        tiredRate: 0,
        feebleRate: 0,
        scoreCoefficient: this.matrixing.value,
        ...gradeForm
      }

      this.model.paramList.forEach(item => {
        params[`${item.type}Rate`] = parseFloat(item.edit)
      })

      this.saveParamLoading = true
      let resp = await updateExamParam(params)
      this.saveParamLoading = false

      if (resp.body) {
        this.showCompScore = params.openComprehensive // 设置是否显示综合分
        this.$message({
          type: 'success',
          message: '修改成功！报告数据重新生成中，请稍后查看'
        })
        this.param.gradeSynthesisScore = gradeForm.gradeSynthesisScore;
        this.param.schoolInequality = gradeForm.schoolInequality;
        this.param.gradeAvg = gradeForm.gradeAvg;
        this.param.gradeScoreLevel = gradeForm.gradeScoreLevel;
        this.param.gradeAvgDistance = gradeForm.gradeAvgDistance;
        this.param.everyTopicPercent = gradeForm.everyTopicPercent;
        this.param.everyoneGradeScorePercent = gradeForm.everyoneGradeScorePercent;
        this.param.gradeRank = gradeForm.gradeRank;
        this.param.personalDefeatSchoolPercent = gradeForm.personalDefeatSchoolPercent;
        this.param.gradeScorePercent = gradeForm.gradeScorePercent;
        // 刷新页面
        if (this.navTab === 2) {
          location.reload();
        }
        this.handleCloseSetting();
      } else {
        this.$message({
          type: 'error',
          message: resp.message
        })
      }
    },

    //点击保存验证数据
    submitForm () {
      if (this.navTab == 0) {
        this.$refs.levelForm.validate((valid) => {
          if (valid) {
            this._saveParam()
          } else {
            return false
          }
        })
      } else if (this.navTab === 2) {
        this.$refs.matrxingForm.validate((valid) => {
          if (valid) {
            this._saveParam()
          } else {
            return false
          }
        })
      } else {
        this._saveParam()
      }
    },

    // 获取考试配置参数
    async _getExamParam () {
      let params = {
        examId: this.examId
      }

      let resp = await getExamParam(params)
      let data = resp.body;
      if (data) {
        this.param = data
        this.gradeForm = {
          gradeDataShow: data.gradeDataShow || 0,
          gradeSynthesisScore: data.gradeSynthesisScore || 0,
          schoolInequality: data.schoolInequality || 0,
          gradeAvg: data.gradeAvg || 0,
          gradeScoreLevel: data.gradeScoreLevel || 0,
          gradeAvgDistance: data.gradeAvgDistance || 0,
          everyTopicPercent: data.everyTopicPercent || 0,
          everyoneGradeScorePercent: data.everyoneGradeScorePercent || 0,
          gradeRank: data.gradeRank || 0,
          personalDefeatSchoolPercent: data.personalDefeatSchoolPercent || 0,
          gradeScorePercent: data.gradeScorePercent || 0
        }
        this.showCompScore = data.openComprehensive
        this.matrixing.value = data.scoreCoefficient
        this.getExamTotalScore()
      }
    },

    async getExamTotalScore () {
      let resp = await examApi.getExamTotalScore(this.examId)
      if (resp.body) {
        this.param.totalScore = resp.body
      }
    },

    //获取系统管理中分数段等级
    async _postGetLevel (exam) {
      await this._getExamParam()
      const courseId = this.getCourseId(exam.subjectCode)
      let resp = await configApi.getSchoolLevels(this.schoolId, exam.grade, courseId)
      if (resp.body && resp.body.length) {
        this.model.paramList = []
        const list = resp.body[0].configurations
        if (list && list.length > 0) {
          this.model.paramList = list.filter(s => s.isShow).map((element, index) => {
            let type = element.configType ? element.configType.replace('SUBJECT_', '').toLowerCase() : index
            return {
              type,
              rank: element.configName,
              percent: parseInt(element.configValue),
              parent: element.configAlias || '未设置',
              edit: this.param[`${type}Rate`] || 0
            }
          })
        }
      }
    },

    changeRouter (name) {
      this.setRoutes(name)
      this.$router.push({
        name: name,
        params: {
          id: this.$route.params.id
        },
        query: this.$route.query
      })
    },

    handleCloseSetting () {
      this.navTab = 0;
      this.navActive = 0;
      this.reportSettingVisible = false;
    },

    changeNav (index) {
      this.navTab = index
      this.navActive = index
    },

    _navbarFixed () {
      let topH = document.body.scrollTop || document.documentElement.scrollTop
      this.fixedClass = topH >= 218 ? 'question-fixed' : ''
    },
    setRoutes (routeName) {
      this.isClassReport = routeName.indexOf('examine-classReport') > -1
      const query = this.$route.params.id + '?isFenBanTongFen=' + this.$route.query.isFenBanTongFen
      if (this.isClassReport) {
        this.routers = [
          {
            path: '/exam/single/report/class/basic/' + query,
            name: '班级基础成绩分析'
          },
          {
            path: '/exam/single/report/class/comment/' + query,
            name: '试卷讲评'
          },
          {
            path: '/exam/single/report/class/ability/' + query,
            name: '知识能力分析'
          },
          {
            path: '/exam/single/report/class/analysis/' + query,
            name: '试题分析'
          },
          {
            path: '/exam/single/report/class/transcript/' + query,
            name: '成绩单'
          },
          {
            path: '/exam/single/report/class/problemSet/' + query,
            name: '题组模块'
          },
          {
            path: '/exam/single/report/class/quality/' + query,
            name: '试卷分析'
          },
          {
            path: '/exam/single/report/class/custom/' + query,
            name: '自定义分析'
          }
        ]
        this.reportNameList = this.classReportList
      } else {
        this.routers = [
          {
            path: '/exam/single/report/grade/basic/' + query,
            name: '基础成绩分析'
          },
          {
            path: '/exam/single/report/grade/ability/' + query,
            name: '知识能力分析'
          },
          {
            path: '/exam/single/report/grade/comment/' + query,
            name: '试题分析'
          },
          {
            path: '/exam/single/report/grade/transcript/' + query,
            name: '成绩单'
          },
          {
            path: '/exam/single/report/grade/problemSet/' + query,
            name: '题组模块'
          },
          {
            path: '/exam/single/report/grade/quality/' + query,
            name: '试卷分析'
          },
          {
            path: '/exam/single/report/grade/custom/' + query,
            name: '自定义分析'
          }
        ]
        this.reportNameList = this.gradeReportList
      }
    },
    handleChange () {
      this.$router.push('/v2/exam/index')
    }
  },
  watch: {
    classId (val, oldVal) {
      if (val) {
        const curClass = this.classList.find(s => s.id == val)
        if (curClass) {
          if (curClass.hasData) {
            this.className = curClass.className
          } else {
            this.$message.warning('该班级未进行扫描，暂无报告')
            this.classId = oldVal
          }
        }
      }
    },
    reportSettingVisible (val) {
      if (val) {
        this._postGetLevel(this.exam)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    watermark.load({ show: false })
    watermark.remove()
    next()
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  height: 40px;
  line-height: 50px;
  font-size: 14px;
  background: #fff;
  color: #333;
  align-items: center;
  border-bottom: #e5e5e5 1px solid;

  .header-back {
    padding-right: 20px;
    cursor: pointer;

    img {
      vertical-align: middle;
      margin-top: -3px;
    }

    &:hover span {
      color: $color-theme;
    }
  }

  .report-button {
    .menu-tab {
      display: inline-block;
      font-size: 14px;
      margin: 0 7px;
      padding: 0 8px;
      color: #404040;
      line-height: 26px;
      font-weight: 500;
      border-radius: 5px;
      -webkit-transition: all 0.2s;
      transition: all 0.2s;
      cursor: pointer;
      color: #333;
      background: #f3f3f3;
    }

    .menu-tab.actived {
      background: $color-theme;
      color: #fff;
    }
  }

  .project-mode {
    margin-right: 20px;
    cursor: pointer;

    img {
      vertical-align: middle;
      margin-top: -8px;
    }

    &:hover span {
      color: $color-theme;
    }
  }

  .export-report {
    img {
      vertical-align: middle;
    }

    &:hover span {
      color: $color-theme;
    }
  }

  span {
    padding-left: 15px;
    vertical-align: middle;
  }
}

.info-wrapper {
  display: flex;
  height: 66px;
  line-height: 66px;
  background: #fff;
  box-shadow: $box-shadow;
  border-radius: 4px;

  .mark {
    position: relative;
    width: 52px;

    span {
      position: absolute;
      top: 6px;
      left: -7px;
      width: 52px;
      height: 20px;
      line-height: 16px;
      text-align: center;
      transform: rotate(-45deg);
      z-index: 1;
      font-size: $font-size;
      color: #fff;
    }

    img {
      position: absolute;
      left: -4px;
      top: -4px;
    }
  }

  .info {
    flex: 1;
    display: flex;
    align-items: center;

    > h4 {
      margin-left: 16px;
      display: inline-block;
      font-size: $font-size-large;
      font-weight: bold;
      color: $color-text;
    }

    .reletive {
      display: inline-block;
      padding-left: 16px;

      img {
        vertical-align: middle;
        width: 18px;
        margin-top: -2px;
      }

      span {
        color: #999999;
        font-size: $font-size;
      }
    }

    .date {
      display: inline-block;
      color: #999999;
      font-size: $font-size;
      padding-left: 16px;

      img {
        margin-top: -2px;
        vertical-align: middle;
      }
    }

    .grading-tip {
      color: #f6566f;
      font-size: 14px;
      margin-left: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 250px;
    }

    .exam-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 300px;
    }

    .report-type {
      margin-left: 20px;
      display: inline-block;
    }
  }

  .model-dialog {
    cursor: pointer;
    color: $color-theme;
    font-size: 14px;
    margin: 0 20px;

    > img {
      display: inline-block;
      vertical-align: middle;
      margin: 0 4px;
    }

    > span {
      font-weight: bold;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .tool {
    .select-round {
      display: inline-block;
      padding: 0 10px;
    }

    img {
      padding: 0 15px;
      vertical-align: middle;
    }
  }
}

.main {
  display: flex;
  box-sizing: border-box;

  .nav {
    width: 155px;
  }
}

.setting-nav {
  margin: 14px auto;
  display: flex;
  justify-content: center;

  &:after {
    display: table;
    content: "";
    clear: both;
    zoom: 1;
  }

  > li {
    float: left;
    padding: 0 20px;
    margin-right: 40px;
    color: $color-text;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border: 2px solid transparent;
    user-select: none;

    &:hover {
      cursor: pointer;
    }

    &.active {
      border-bottom-color: $color-theme;
    }
  }
}

.setting-body {
  width: 620px;
  margin: 0 auto;

  .el-select {
    margin-right: 16px;
    width: 130px;
  }

  .el-table {
    margin: 30px auto;

    .el-form-item {
      align-items: center;
      margin: 0;
    }

    .el-input--suffix .el-input__inner {
      background-color: #f5f5f5;
      text-align: center;
      padding: 0;
    }

    .level-input {
      width: 80%;
    }
  }

  .el-table td,
  .el-table th.is-leaf {
    text-align: center;
  }

  .submit {
    text-align: center;
  }
}

.count-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .top-form {
    width: 560px;
    margin: 30px auto;
  }

  .submit {
    text-align: center;
  }
}

.export-report {
  width: 460px;
  float: right;
  margin-right: 10px;

  .top {
    float: right;
    cursor: pointer;
    padding: 0 10px;
    height: 22px;
    border-radius: 2px;
    line-height: 22px;
    padding-right: 5px;
    text-align: right;
    box-sizing: border-box;

    span {
      padding: 0 5px;
    }
  }

  .content {
    border: 1px solid #ccc;
    overflow: hidden;
    font-size: 12px;
    width: 460px;
    position: absolute;
    margin-right: 0;
    background-color: white;
    box-sizing: border-box;
    border-radius: 3px;
    box-shadow: 0 0 2px 2px rgba(204, 204, 204, 0.7);
    z-index: 100;

    .section_head {
      padding: 0 20px;
      background: #eff0f1;
      height: 30px;
      line-height: 30px;
      color: #919293;
    }

    .section_list {
      padding: 0 20px;

      i {
        color: #bbb;
      }
    }

    .section_bottom {
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
    }
  }

  .el-checkbox + .el-checkbox {
    margin-left: 0;
  }
}

.nav-wrap {
  position: relative;
  margin: 16px 8px 0 0;
  width: 155px;

  .question-fixed {
    position: fixed;
    top: 60px;
  }
}

.report-modal-content {
  height: 150px;
  line-height: 150px;
  text-align: center;

  > label {
    color: #333;
  }

  > span {
    color: $color-theme;
  }
}

.loading-bg {
  margin-top: 15px;
  background: #fff;
  height: calc(100vh - 310px);
  text-align: center;
  color: #777;
  font-size: 15px;
  box-shadow: $box-shadow;
  display: flex;
  align-items: center;
  justify-content: center;
}

.export-grade-report {
  .export-grade-header {
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      color: #999;
      font-size: 14px;
      padding-right: 10px;
    }
  }
}

.qrcode {
  margin-top: 10px;
  padding: 12px 11px;
  width: 155px;
  background-color: $color-theme;
  color: #fff;
  text-align: center;
  box-sizing: border-box;
  border-radius: 3px;

  img {
    width: 100%;
  }

  div {
    padding-top: 12px;
    line-height: 24px;
    font-size: 14px;
  }

  p {
    font-size: 12px;
    line-height: 26px;
  }
}
</style>

<style lang="scss">
.basic-single-report .select-round {
  display: inline-block;

  .el-select__caret {
    color: #fff !important;
  }

  .el-select {
    width: 85px;

    .el-input {
      .el-input__inner {
        color: #fff;
        text-align: center;
        border-radius: 20px;
        border-color: $color-theme;
        background: $color-theme;
      }
    }
  }
}

.more-data {
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 14px;
  border: 1px solid #ebeef5;
  background: #fff;
  border-top: none;
  cursor: pointer;

  &:hover {
    color: $color-theme;
    background: #f5f7fa;
  }
}

.layout-export-btn {
  text-align: center;
}

//信息生成动效
.spinner > div {
  width: 30px;
  height: 30px;
  background-color: #3a84d8;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
  animation: bouncedelay 1.4s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }

  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }

  40% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}

.screen_login {
  padding-right: 10px;
  display: inline-block;
  cursor: pointer;
  color: #333;

  > img {
    padding-right: 5px !important;
  }

  > span {
    font-size: 14px;
  }

  &:hover {
    color: $color-theme;
  }
}
</style>